type DashboardSizeConfiguration = {
	id: string;
	width: number;
	height: number;
};

const defaultSizeConfiguration: DashboardSizeConfiguration = {
	id: '',
	width: 1366,
	height: 915
};

const graduateEmploymentSizeConfiguration: DashboardSizeConfiguration = {
	id: 'ACT87',
	width: 1750,
	height: 1550
};

export { defaultSizeConfiguration, graduateEmploymentSizeConfiguration, DashboardSizeConfiguration };